export default "__VITE_ASSET__zkx7QmiG__"